<template>
  <div>
    <bar-chart :xdata="xdata" :series="series" :rotate='45' :type="'illness'" />
  </div>
</template>
<script>
// 柱状图
import BarChart from '@/components/layouts/BarChart';
export default {
  computed: {
    xdata() {
      let arr = [];
      this.illnessArr.map((item) => {
        arr.push(item.sicknessName);
      });
      return arr;
    },
    series() {
      let data = [];
      this.illnessArr.map((item) => {
        //  data.push(item.caseNum)
        data.push({
          name: item.sicknessName,
          value: item.caseNum,
          datas: [item.insuredNum, item.totalAmount],
        });
      });
      //    caseNum:item.caseNum+'件',
      //    insuredNum:item.insuredNum+'人',
      //    totalAmount:'￥'+item.totalAmount
      return [
        {
          // name: 'pageA',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: data,
          animationDuration: 2000,
          barMaxWidth:30
        },
      ];
    },
  },
  props: {
    illnessArr: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BarChart,
  },
};
</script>
<style >
.charttips {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #aaaaaf;
  line-height: 16px;
  text-align: center;
  padding-top: 30px;
}
</style>